module.exports = __webpack_public_path__ + "static/media/Logo_app_white.2b98a4fc.png";